module.exports = __webpack_public_path__ + "img/file-shield-solid.361cb78e.svg";